
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"profile-references-star","fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.483 35.666l1.521-.799c.424-.222.93-.222 1.353 0l1.522.8a1.45 1.45 0 001.53-.112l.57-.413c.446-.324.67-.876.578-1.42l-.291-1.695c-.08-.47.075-.953.418-1.287l1.23-1.199c.396-.387.54-.964.369-1.49l-.217-.667a1.455 1.455 0 00-1.173-.99l-1.701-.248a1.454 1.454 0 01-1.095-.796l-.76-1.542A1.462 1.462 0 0033.028 23h-.702c-.554 0-1.06.314-1.304.81l-.76 1.542a1.454 1.454 0 01-1.095.796l-1.7.245a1.455 1.455 0 00-1.173.99l-.216.668c-.17.526-.03 1.104.368 1.49l1.23 1.2c.343.333.5.815.419 1.286l-.292 1.694a1.452 1.452 0 00.58 1.421l.568.413c.447.324 1.04.368 1.53.111z"}})]),_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M24.676 37.015h-13.34a3.334 3.334 0 01-3.334-3.335V10.337a3.334 3.334 0 013.335-3.335h21.676a3.334 3.334 0 013.334 3.335V19.5M14.671 13.672h15.007M14.671 20.341h6.67M14.671 27.01h5.003"}})]),_c('g',{staticClass:"bcx-icon-shadow"},[_c('mask',{attrs:{"id":"path-5-inside-1_3487_11575","fill":"#fff"}},[_c('use',{attrs:{"href":"#profile-references-star","stroke-width":"0"}})]),_c('use',{attrs:{"href":"#profile-references-star","fill":"var(--background-color)","stroke":"currentColor","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round","mask":"url(#path-5-inside-1_3487_11575)"}})])])
          )
        }
      }
    